import { Modal } from "antd";
import { useEffect, useState } from "react";
import { timeBankMaintenanceService } from "../../../../redux/services";
import moment from "moment";

const ModalHoursBank = ({ visible, onClose, data }) => {
  const [isSending, setIsSending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentBalanceData, setCurrentBalanceData] = useState({});

  const onFinish = () => {
    timeBankMaintenanceService.create({
      acao: "fechar_banco_hora",
      data: data.data_demissao ? moment(data.data_demissao).format('YYYY-MM-DD') : moment().subtract(1, 'day').format('YYYY-MM-DD'),
      empresas: [data.empresa_id],
      funcionarios: [data.funcionario_id],
      status: true,
    })
    onClose({ ...data, cleaned: true });
  }

  const getCurrentHourBalance = () => {
    timeBankMaintenanceService.getCurrentBalance({
      funcionario: data.funcionario_id,
      empresa: data.empresa_id,
      data: data.data_demissao ? moment(data.data_demissao).format('YYYY-MM-DD') : moment().subtract(1, 'day').format('YYYY-MM-DD'),
    })
      .then((response) => {
        setCurrentBalanceData(response.data);
        const valorFecharBanco = response.data.valor_fechar_banco_hora ?? null;

        if (visible && (typeof valorFecharBanco === 'string' && valorFecharBanco !== '00:00:00')) {
          setShowModal(true);
        } else {
          onClose(data);
        }
      })
  }

  useEffect(() => {
    if (data?.funcionario_id) getCurrentHourBalance();
  }, [data]);

  return (
    <Modal
        visible={showModal}
        title="Limpar saldo de Banco de Horas"
        keyboard={false}
        centered
        destroyOnClose={true}
        maskClosable={false}
        closable={false}
        width={500}
        okText="Limpar"
        cancelText="Manter"
        onOk={onFinish}
        confirmLoading={isSending}
        cancelButtonProps={{ disabled: isSending }}
        onCancel={() => onClose(data)}
        className="modal-clear-hours-bank"
    >
      <div>
        O Funcionário possui um saldo de {currentBalanceData?.sinal === '-' ? '-' : ''}{showModal && (currentBalanceData.valor_fechar_banco_hora ?? '00:00:00').slice(0, 5)} em banco de horas.{' '}
        Deseja limpar ou manter o saldo?
      </div>
    </Modal>
  )
}

export default ModalHoursBank;